export function updateInfernos(roundData, currentTick, getConvertedCords, getObjectOpacity) {
  if (!roundData || !roundData.infernos) return [];

  const activeInfernos = [];

  roundData.infernos.forEach((inferno) => {
    const startTick = inferno.startTick || 0;
    const endTick = inferno.endTick || Infinity;

    if (currentTick >= startTick && currentTick < endTick) {
      let activeFire = null;

      if (inferno.fires && inferno.fires.length > 0) {
        inferno.fires.forEach((fire) => {
          if (fire.tick <= currentTick) {
            if (!activeFire || fire.tick > activeFire.tick) {
              activeFire = fire;
            }
          }
        });
      }

      if (activeFire && activeFire.points && activeFire.points.length > 0) {
        const firePoints = activeFire.points
          .map((point) => {
            if (point.x !== undefined && point.y !== undefined) {
              return getConvertedCords(point.x, point.y);
            }
            return null;
          })
          .filter((p) => p !== null);

        if (firePoints.length > 2) {
          const centerX = firePoints.reduce((sum, p) => sum + p.x, 0) / firePoints.length;
          const centerY = firePoints.reduce((sum, p) => sum + p.y, 0) / firePoints.length;

          const burnTime = inferno.burnTime || 7.0;
          const elapsed = (currentTick - startTick) / 64;
          const remaining = Math.max(0, burnTime - elapsed);
          const timer = remaining.toFixed(1);

          const opacity = Math.min(1, remaining / burnTime) * 0.7;

          activeInfernos.push({
            uniqueID: inferno.uniqueID,
            points: firePoints,
            textX: centerX,
            textY: centerY,
            timer,
            opacity,
          });
        }
      } else if (inferno.x !== undefined && inferno.y !== undefined) {
        const cords = getConvertedCords(inferno.x, inferno.y);
        if (cords) {
          const burnTime = inferno.burnTime || 7.0;
          const elapsed = (currentTick - startTick) / 64;
          const remaining = Math.max(0, burnTime - elapsed);
          const timer = remaining.toFixed(1);
          const opacity = Math.min(1, remaining / burnTime) * 0.7;

          const radius = 30;
          const firePoints = [
            { x: cords.x - radius, y: cords.y - radius },
            { x: cords.x + radius, y: cords.y - radius },
            { x: cords.x + radius, y: cords.y + radius },
            { x: cords.x - radius, y: cords.y + radius },
          ];

          activeInfernos.push({
            uniqueID: inferno.uniqueID,
            points: firePoints,
            textX: cords.x,
            textY: cords.y,
            timer,
            opacity,
          });
        }
      }
    }
  });

  return activeInfernos;
}
